import {
  MISSION_PROFILE_ADD,
  MISSION_PROFILE_REMOVE,
  MISSION_PROFILE_UPDATE,
  POWER_ON_ADD,
  POWER_ON_REMOVE,
  POWER_ON_UPDATE,
  POWER_OFF_ADD,
  POWER_OFF_REMOVE,
  POWER_OFF_UPDATE
}from './constants'

const missionProfileAdd = () => ({ type: MISSION_PROFILE_ADD })
const missionProfileRemove = (index) => ({ type: MISSION_PROFILE_REMOVE, index})
const missionProfileUpdate = (index, element, value) => ({ type: MISSION_PROFILE_UPDATE, index, element, value })

const powerOnAdd = (mpIndex) => ({ type: POWER_ON_ADD, mpIndex })
const powerOnRemove = (mpIndex, index) => ({ type: POWER_ON_REMOVE, mpIndex, index})
const powerOnUpdate = (mpIndex, index, element, value) => ({ type: POWER_ON_UPDATE, mpIndex, index, element, value })

const powerOffAdd = (mpIndex) => ({ type: POWER_OFF_ADD, mpIndex })
const powerOffRemove = (mpIndex, index) => ({ type: POWER_OFF_REMOVE, mpIndex, index})
const powerOffUpdate = (mpIndex, index, element, value) => ({ type: POWER_OFF_UPDATE, mpIndex, index, element, value })

export {
  missionProfileAdd,
  missionProfileRemove,
  missionProfileUpdate,
  powerOnAdd,
  powerOnRemove,
  powerOnUpdate,
  powerOffAdd,
  powerOffRemove,
  powerOffUpdate
}